import { ReactComponent as InfoCircle } from "@/assets/svgs/info-circle.svg";
import Button from "@/components/Button/index";
import CardConfigure from "@/components/CardConfigure/index";
import Modal from "@/components/Modal/index";
import rem from "@/utils/rem";
import { PropTypes } from "prop-types";

const SharePrincipalInfoModal = ({ visible, hide }) => {
	return (
		<Modal visible={visible}>
			<CardConfigure
				addHeaderClass="eap-modal__header"
				style={{
					maxWidth: rem(500),
					position: "relative",
					top: rem(40),
				}}
			>
				<CardConfigure.Header>
					<CardConfigure.Header.Icon round>
						<div className="tnc-modal__icon">
							<InfoCircle />
						</div>
					</CardConfigure.Header.Icon>
					<CardConfigure.Header.Title>
						Share principal list
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div className="eap-modal__content center">
							By enabling this function, you will be displaying
							your list of Principal(s) to all users. Users will
							be able to view your Principal(s) within specific
							use cases and can initiate consent with you to
							provide or consume data on behalf of these
							Principal(s).
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button
							full
							maxWidth="100"
							submit={() => hide()}
							text="Okay, got it!"
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
};

SharePrincipalInfoModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
};

export default SharePrincipalInfoModal;
